import * as yup from "yup";
const IMAGE_SUPPORTED_FORMATS = ["image/jpeg", "image/png"];

// const PHONE_REGEX =
//   /^(\+1|1)?[-.\s]?\(?[0-9]{3}\)?[-.\s]?[0-9]{3}[-.\s]?[0-9]{4}$/;
const PHONE_REGEX =
  /^\+?[1-9]\d{1,14}$/;

export const stepOneSchema = yup.object({
  doctorName: yup.string().required("Doctor name is required."),
  firstName: yup.string().required("First name is required."),
  lastName: yup.string().required("Last name is required."),
  doctorPhoto: yup.mixed().required("Doctor photo is required."),
});

export const stepTwoSchema = yup.object({
  postal_code: yup.string().required("Required"),
  accountCardEntry: yup.string(),
  emailForReceipts: yup
    .string()
    .email("Invalid email address")
    .required("Required"),
  nameOnAccount: yup.string().required("Required"),

  billingAddress: yup.object({
    contactName: yup.string().required("Required"),
    billingEmail: yup
      .string()
      .email("Invalid email address")
      .required("Required"),
    streetAddress: yup.string().required("Required"),
    city: yup.string().required("Required"),
    state: yup.string().required("Required"),
    // postalCode: yup
    //   .string()
    //   .matches(/^\d{5}$/, "Postal Code must be exactly 5 digits")
    //   .required("Postal Code is required"),
    postalCode: yup
      .string()
      .when('country', (country, schema) => {
        if (country[0] === 'US') {
          return schema
            .matches(/^\d{5}$/, 'Postal Code must be exactly 5 digits')
            .required('Postal Code is required for United States');
        }
        return schema.required('Postal Code is required');
      }),
    country: yup.string().required("Required"),
  }),
});

export const stepThreeSchema = yup.object().shape({
  bigGoal: yup.string().required("Big Goal is required"),
  // twelveMonthGoal: yup.string().required("12 Month Goal is required"),
  futurePlans: yup.string().required("Future Plans are required"),
  patientAcquisition: yup
    .string()
    .required("Patient Acquisition information is required"),
  currentPatientVolume: yup
    .string()
    .required("Current Patient Volume is required"),
  futurePatientVolume: yup
    .string()
    .required("Future Patient Volume is required"),
  socialMediaManagement: yup
    .string()
    .required("Social Media Management information is required"),
  referralSources: yup
    .string()
    .required("Referral Sources information is required"),
  referralDestinations: yup
    .string()
    .required("Referral Destinations information is required"),
  websiteManagement: yup
    .string()
    .required("Website Management information is required"),
  seoManagement: yup
    .string()
    .required("SEO Management information is required"),
  scheduling: yup.string().required("Scheduling information is required"),
  appointment: yup.string().required("Appointment information is required"),
  socialMediaIntegration: yup
    .string()
    .required("Social Media Integration information is required"),
});

export const stepFourSchema = yup.object({
  virtualTrainingTiming: yup.string().required("This field is required."),
  schedulingContact: yup.string().required("This field is required."),
  totalStaff: yup.string().required("Total staff is required"),
  communications: yup.array().of(
    yup.object({
      name: yup.string(),
      email: yup.string().email("Invalid email format"),
      title: yup.string(),
    })
  ),
  optical: yup.array().of(
    yup.object({
      name: yup.string(),
      email: yup.string().email("Invalid email format"),
      title: yup.string(),
    })
  ),
  billing: yup.array().of(
    yup.object({
      name: yup.string(),
      email: yup.string().email("Invalid email format"),
      title: yup.string(),
    })
  ),
  screening: yup.array().of(
    yup.object({
      name: yup.string(),
      email: yup.string().email("Invalid email format"),
      title: yup.string(),
    })
  ),
  firstName: yup.string().required("First Name is required"),
  lastName: yup.string().required("Last Name is required"),
  email: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  phone: yup.string().required("Phone is required"),
  aboCertifiedAndExperience: yup
    .string()
    .required("Please provide information on ABO certification or experience"),
});

export const stepFiveSchema = yup.object({
  labFacilities: yup.string().required("This field is required."),
  preferredLensLab: yup.string().required("This field is required."),
  cherryOpticalAccount: yup.string().required("This field is required."),
  ehrSystem: yup.string().required("This field is required."),
  equipmentDescription: yup.string().required("This field is required."),
  lensometerType: yup.string().required("This field is required."),
  prismMeasurementTools: yup.string().required("This field is required."),
  refractorType: yup.string().required("This field is required."),
  manualPhoropter: yup.string().required("This field is required."),
  officeBillingContact: yup.object({
    firstName: yup.string().required("First name is required"),
    lastName: yup.string().required("Last name is required"),
    email: yup
      .string()
      .email("Invalid email address")
      .required("Email is required"),
    phone: yup
      .string()
      .matches(/^[\d\s-+()]*$/, "Invalid phone number")
      .required("Phone number is required"),
    billingCompanyName: yup.string(),
    relationToPractice: yup
      .string()
      .oneOf(["Internal", "External", "Contract"], "Invalid relation type")
      .required("Relation to practice is required"),
  }),
  additionalBillingContacts: yup.object({
    email: yup
      .string()
      .email("Invalid email address")
      .required("Email is required"),
    phone: yup
      .string()
      .matches(/^[\d\s-+()]*$/, "Invalid phone number")
      .required("Phone number is required"),
  }),
  insuranceBilling: yup.object({
    whoBillsMedicalInsurance: yup.string().required("This field is required"),
    medicalInsuranceAccepted: yup.string().required("This field is required"),
    visionPlansAccepted: yup.string().required("This field is required"),
    challengesWithVisionBilling: yup
      .string()
      .required("This field is required"),
    challengesWithMedicalBilling: yup
      .string()
      .required("This field is required"),
    handlingRejections: yup.string().required("This field is required"),
    outsourcingInformation: yup.string().required("This field is required"),
    clearingHouseUtilized: yup.string().required("This field is required"),
  }),
});

const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

const emailSchema = yup.string()
  .trim()
  .lowercase()
  .required("Email is required")
  .test('email-format', 'Please enter a valid email address', function (value) {
    if (!value) return false;
    return emailRegex.test(value);
  })
  .test('email-length', 'Email address is too long', function (value) {
    if (!value) return false;
    return value.length <= 254;
  })
  .test('local-part-length', 'Email username is too long', function (value) {
    if (!value) return false;
    const localPart = value.split('@')[0];
    return localPart && localPart.length <= 64;
  })
  .test('domain-valid', 'Invalid email domain', function (value) {
    if (!value) return false;
    const domain = value.split('@')[1];
    if (!domain) return false;

    const domainRegex = /^[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    if (!domainRegex.test(domain)) return false;

    if (!domain.includes('.')) return false;

    const tld = domain.split('.').pop();
    if (!tld || tld.length < 2 || tld.length > 63) return false;

    return true;
  });

export const stepSixSchema = yup.object().shape({
  // isArchived: yup.boolean(),
  officeName: yup.string().required("Practice Name is required"),
  streetAddress: yup.string().required("Street Address is required"),
  city: yup.string(),
  state: yup.string().required("State is required"),
  country: yup.string().required("Country is required"),
  // pinCode: yup
  //   .string()
  //   .matches(/^\d{5}$/, "Pin Code must be exactly 5 digits")
  //   .required("Pin Code is required"),
  pinCode: yup
    .string()
    .when('country', (country, schema) => {
      if (country[0] === 'US') {
        return schema
          .matches(/^\d{5}$/, 'Pin Code must be exactly 5 digits')
          .required('Pin Code is required for United States');
      }
      return schema.required('Pin Code is required');
    }),

  phone: yup
    .string()
    .matches(PHONE_REGEX, "Invalid phone number format")
    .required("Phone is required"),
  fax: yup.string().required("Fax is required"),
  website: yup.string().required("Website is required"),
  email: emailSchema,

  bvdqEmail: yup
    .array()
    .of(
      emailSchema
    )
    .min(1, "At least one BVDQ email is required")
    .required("BVDQ email is required"),
  // locationStatus: yup.boolean(),
  aboutMe: yup.string().required("Description  are required"),
  // medicalInsuranceStatus: yup.boolean(),
  insurance_details: yup.array().required("insuranceDetails are requireed"),
  // practiceLogo: yup
  //   .mixed()
  //   // .nullable()
  //   .required("Practice Logo is required")
  //   .test(
  //     "fileFormat",
  //     "Unsupported file format. Only jpg, jpeg, and png are allowed",
  //     (value) => {
  //       if (!value) return false;
  //       return IMAGE_SUPPORTED_FORMATS.includes(value.type);
  //     }
  //   ),
  practiceLogo: yup
    .mixed()
    .required("Practice logo is required")
    .test("fileExists", "Practice logo is required", (value) => {
      return value instanceof File;
    })
    .test(
      "fileFormat",
      "Unsupported file format. Only jpg, jpeg, and png are allowed",
      (value) => {
        if (!value || !(value instanceof File)) return true;
        return IMAGE_SUPPORTED_FORMATS.includes(value.type);
      }
    ),
    // locationTag: yup.string().nullable(),
  // bvdqEmails: yup.array()
  //   .of(
  //     yup.string()
  //       .email("Invalid email")
  //       .required("Email is required")
  //   ),
});

export const stepSixOnboardSchema = yup.object().shape({
  officeName: yup.string().required("Practice Name is required"),
  streetAddress: yup.string().required("Street Address is required"),
  city: yup.string().required("City is required"),
  state: yup.string().required("State is required"),
  country: yup.string().required("Country is required"),
  pinCode: yup
    .string()
    .matches(/^\d{5}$/, "Pin Code must be exactly 5 digits")
    .required("Pin Code is required"),
  phone: yup
    .string()
    .matches(PHONE_REGEX, "Invalid phone number format")
    .required("Phone is required"),
  fax: yup.string().required("Fax is required"),
  website: yup.string().required("Website is required"),
  email: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  practiceLogo: yup
    .mixed()
    .nullable()
    .test(
      "fileFormat",
      "Unsupported file format. Only jpg, jpeg, and png are allowed",
      (value) => {
        if (!value) return false;
        return IMAGE_SUPPORTED_FORMATS.includes(value.type);
      }
    ),
});

export const stepSevenSchema = yup.object({
  preTrainingCall: yup.string().required("Required"),
  // doctorFullName: yup.string().required("Required"),
  birthday: yup.date().nullable().required("Birthday is required"),
  address: yup.string().required("Required"),
  phone: yup
    .string()
    .matches(PHONE_REGEX, "Invalid phone number format")
    .required("Phone is required."),
  email: yup.string().email("Invalid email address").required("Required"),
  maritalStatus: yup.string().required("Required"),
  healthConditions: yup.string().required("Required"),
  // departmentsOfInterest: yup.string().required("Required"),
  additionalDepartmentInterests: yup.object({
    lab: yup.boolean().default(false),
    opticians: yup.boolean().default(false),
    communications: yup.boolean().default(false),
    scribes: yup.boolean().default(false),
    programManager: yup.boolean().default(false),
    billingDepartment: yup.boolean().default(false),
    generalManager: yup.boolean().default(false),
  }),
});

export const stepEightSchema = yup.object({
  totalStaff: yup.string().required("Total staff is required"),
  communications: yup.array().of(
    yup.object({
      name: yup.string().required("Name is required"),
      email: yup
        .string()
        .email("Invalid email format")
        .required("Email is required"),
      title: yup.string().required("Title is required"),
    })
  ),
  optical: yup.array().of(
    yup.object({
      name: yup.string().required("Name is required"),
      email: yup
        .string()
        .email("Invalid email format")
        .required("Email is required"),
      title: yup.string().required("Title is required"),
    })
  ),
  billing: yup.array().of(
    yup.object({
      name: yup.string().required("Name is required"),
      email: yup
        .string()
        .email("Invalid email format")
        .required("Email is required"),
      title: yup.string().required("Title is required"),
    })
  ),
  screening: yup.array().of(
    yup.object({
      name: yup.string().required("Name is required"),
      email: yup
        .string()
        .email("Invalid email format")
        .required("Email is required"),
      title: yup.string().required("Title is required"),
    })
  ),
});

export const stepNineSchema = yup.object({
  neuroVisualCoordinator: yup.object({
    firstName: yup.string().required("First Name is required"),
    lastName: yup.string().required("Last Name is required"),
    preferredName: yup.string().required("Preferred Name is required"),
    email: yup
      .string()
      .email("Invalid email address")
      .required("Email is required"),
    phone: yup
      .string()
      .matches(PHONE_REGEX, "Invalid phone number format")
      .required("Phone is required"),
    currentRoleInPractice: yup
      .string()
      .required("Current Role in Practice is required"),
    referralBVDQResultsEmail: yup
      .string()
      .email("Invalid email address")
      .required("Referral BVDQ™ Results Email is required"),
  }),
  nvmExamPreparation: yup.object({
    // doctorFullName: yup.string().required('Doctor Full Name is required'),
    track_medicine: yup.string().required("This Field is required"),
    birthday: yup
      .date()
      .nullable() // Allow the field to be null when the condition isn't met
      .when("track_medicine", {
        is: "yes", // The condition
        then: (schema) => schema.required("Birthday is required."),
        otherwise: (schema) => schema.nullable(), // Make the field nullable if not required
      }),
    address: yup.string().when("track_medicine", {
      is: "yes",
      then: (schema) => schema.required("Address is required."),
      otherwise: (schema) => schema.nullable(),
    }),
    phone: yup
      .string()
      .matches(PHONE_REGEX, "Invalid phone number format")
      .when("track_medicine", {
        is: "yes",
        then: (schema) => schema.required("Phone is required."),
        otherwise: (schema) => schema.nullable(),
      }),
    emailAddress: yup
      .string()
      .email("Invalid email address")
      .when("track_medicine", {
        is: "yes",
        then: (schema) => schema.required("Email Address is required."),
        otherwise: (schema) => schema.nullable(),
      }),
    maritalStatus: yup.string().when("track_medicine", {
      is: "yes",
      then: (schema) => schema.required("Marital Status is required."),
      otherwise: (schema) => schema.nullable(),
    }),
    healthConditions: yup.string().when("track_medicine", {
      is: "yes",
      then: (schema) => schema.required("Health Conditions are required."),
      otherwise: (schema) => schema.nullable(),
    }),
  }),
});

export const stepTenSchema = yup.object({
  officeBillingContact: yup.object({
    firstName: yup.string().required("First name is required"),
    lastName: yup.string().required("Last name is required"),
    email: yup
      .string()
      .email("Invalid email address")
      .required("Email is required"),
    phone: yup
      .string()
      .matches(/^[\d\s-+()]*$/, "Invalid phone number")
      .required("Phone number is required"),
    billingCompanyName: yup.string(),
    relationToPractice: yup
      .string()
      .oneOf(["Internal", "External", "Contract"], "Invalid relation type")
      .required("Relation to practice is required"),
  }),
  additionalBillingContacts: yup.object({
    email: yup
      .string()
      .email("Invalid email address")
      .required("Email is required"),
    phone: yup
      .string()
      .matches(/^[\d\s-+()]*$/, "Invalid phone number")
      .required("Phone number is required"),
  }),
  insuranceBilling: yup.object({
    whoBillsMedicalInsurance: yup.string().required("This field is required"),
    medicalInsuranceAccepted: yup.string().required("This field is required"),
    visionPlansAccepted: yup.string().required("This field is required"),
    challengesWithVisionBilling: yup
      .string()
      .required("This field is required"),
    challengesWithMedicalBilling: yup
      .string()
      .required("This field is required"),
    handlingRejections: yup.string().required("This field is required"),
    outsourcingInformation: yup.string().required("This field is required"),
    clearingHouseUtilized: yup.string().required("This field is required"),
  }),
});

export const stepElevenSchema = yup.object({
  firstName: yup.string().required("First Name is required"),
  lastName: yup.string().required("Last Name is required"),
  email: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  phone: yup.string().required("Phone is required"),
  aboCertifiedAndExperience: yup
    .string()
    .required("Please provide information on ABO certification or experience"),
});

export const stepTwelveSchema = yup.object().shape({
  managerFirstName: yup.string().required("First Name is required"),
  managerLastName: yup.string().required("Last Name is required"),
  managerEmail: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  managerPhone: yup
    .string()
    .matches(PHONE_REGEX, "Invalid phone number format")
    .required("Phone is required"),
  ownerFirstName: yup.string().required("First Name is required"),
  ownerLastName: yup.string().required("Last Name is required"),
  ownerEmail: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  ownerPhone: yup
    .string()
    .matches(PHONE_REGEX, "Invalid phone number format")
    .required("Phone is required"),

  notes: yup.string().required("Additional notes are required"),
});
